import type { CSSProperties } from "react";
import { t } from "../i18n";
import { themeIDs, themes, type ThemeID } from "../theme";

export const themeName = (id: ThemeID): string =>
  ({
    lantern: "Lantern",
    aubergine: t("Aubergine"),
    forest: t("Forest"),
    ocean: t("Ocean"),
    ember: t("Ember"),
    graphite: t("Graphite"),
  })[id];

// ThemePicker chooses a color theme from small pictures of each: its
// sidebar, with a channel selected in its accent, beside a page in the mode
// in use. With workspace set, the first choice, "", is the workspace's.
export function ThemePicker({ value, onChange, workspace, mode }: { value: string; onChange: (id: string) => void; workspace?: ThemeID; mode: "light" | "dark" }) {
  const choices: [string, ThemeID, string][] = [
    ...(workspace ? [["", workspace, t("Workspace's: {name}", { name: themeName(workspace) })] as [string, ThemeID, string]] : []),
    ...themeIDs.map((id): [string, ThemeID, string] => [id, id, themeName(id)]),
  ];
  return (
    <div className="theme-picker" role="radiogroup" aria-label={t("Color theme")}>
      {choices.map(([v, id, label]) => {
        const c = themes[id][mode];
        return (
          <label key={v || "workspace"} className="theme-tile">
            <input type="radio" name="color-theme" checked={value === v} onChange={() => onChange(v)} />
            <span className="theme-preview" style={{ "--p-side": c.side, "--p-fg": c.sideFg, "--p-accent": c.accent } as CSSProperties} aria-hidden>
              <span className="p-side">
                <i />
                <i className="p-on" />
                <i />
              </span>
              <span className="p-main">
                <i />
                <i />
                <b />
              </span>
            </span>
            <span className="theme-label">{label}</span>
          </label>
        );
      })}
    </div>
  );
}
